/* CUSTOM: promotion popup triggers and section lifecycle. */
if (!customElements.get('promotion-popup')) {
  customElements.define(
    'promotion-popup',
    class PromotionPopup extends HTMLElement {
      constructor() {
        super();
        this.cookieName = '_halo_promotion_popup';
        this.onClose = this.setClose.bind(this);
        this.onScroll = this.scheduleScrollCheck.bind(this);
        this.onKeyup = this.handleKeyup.bind(this);
        this.onSectionSelect = this.handleSectionSelect.bind(this);
        this.onSectionDeselect = this.handleSectionDeselect.bind(this);
        this.onSectionUnload = this.handleSectionUnload.bind(this);
      }

      connectedCallback() {
        this.drawer = this.closest('.drawer');
        this.closeButton = this.querySelector('.promotion-popup__close');
        this.overlay = this.drawer.querySelector('[id^="Drawer-Overlay-"]');
        this.closeButton.addEventListener('click', this.onClose);
        this.overlay.addEventListener('click', this.onClose);
        this.drawer.addEventListener('keyup', this.onKeyup);
        if (Shopify.designMode) {
          document.addEventListener('shopify:section:select', this.onSectionSelect);
          document.addEventListener('shopify:section:deselect', this.onSectionDeselect);
          document.addEventListener('shopify:section:unload', this.onSectionUnload);
        }
        this.load();
      }

      disconnectedCallback() {
        this.cancelTrigger();
        this.closeButton.removeEventListener('click', this.onClose);
        this.overlay.removeEventListener('click', this.onClose);
        this.drawer.removeEventListener('keyup', this.onKeyup);
        document.removeEventListener('shopify:section:select', this.onSectionSelect);
        document.removeEventListener('shopify:section:deselect', this.onSectionDeselect);
        document.removeEventListener('shopify:section:unload', this.onSectionUnload);
        if (this.opened) this.setClose();
      }

      load() {
        if (Shopify.designMode) return;
        if (new URLSearchParams(window.location.search).get('newsletter') === '1') {
          this.setOpen(0, true);
          return;
        }
        if (this.getCookie(this.cookieName)) return;
        if (this.querySelector('.form__message')) {
          this.setOpen(0);
        } else if (this.dataset.trigger === 'scroll') {
          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onScroll);
          window.addEventListener('pageshow', this.onScroll);
          this.scheduleScrollCheck();
        } else {
          this.setOpen(Number(this.dataset.delay));
        }
      }

      scheduleScrollCheck() {
        if (this.scrollFrame || this.opened) return;
        this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = null;
          const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
          if (scrollableHeight <= 0) return;
          const threshold = Number(this.dataset.scrollPercentage);
          if (window.scrollY * 100 >= scrollableHeight * threshold) this.setOpen(0);
        });
      }

      cancelTrigger() {
        clearTimeout(this.openTimer);
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = null;
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        window.removeEventListener('pageshow', this.onScroll);
      }

      setOpen(delay, force = false) {
        this.cancelTrigger();
        if (this.opened || !this.querySelector('.promotion-popup__image, .promotion-popup__info')) return;
        this.openTimer = setTimeout(() => {
          if (!this.isConnected || (!force && !Shopify.designMode && this.getCookie(this.cookieName))) return;
          this.activeElement = document.activeElement;
          this.opened = true;
          this.drawer.classList.add('active');
          document.body.classList.add('overflow-hidden');
          trapFocus(this.drawer, this.closeButton);
        }, delay);
      }

      setClose() {
        this.cancelTrigger();
        if (!Shopify.designMode) this.setCookie(this.cookieName, 'closed', Number(this.dataset.expire));
        this.drawer.classList.remove('active');
        if (this.opened) {
          document.body.classList.remove('overflow-hidden');
          removeTrapFocus(this.activeElement);
        }
        this.opened = false;
      }

      handleKeyup(event) {
        if (event.code === 'Escape' && this.opened) this.setClose();
      }

      handleSectionSelect(event) {
        if (event.detail.sectionId === this.dataset.sectionId) this.setOpen(0);
      }

      handleSectionDeselect(event) {
        if (event.detail.sectionId === this.dataset.sectionId) this.setClose();
      }

      handleSectionUnload(event) {
        // The theme's side-drawer moves itself outside the original section wrapper.
        if (event.detail.sectionId === this.dataset.sectionId) this.drawer.remove();
      }

      setCookie(name, value, days) {
        const expires = new Date(Date.now() + days * 86400000);
        document.cookie = `${name}=${value};path=/;expires=${expires.toUTCString()};SameSite=Lax`;
      }

      getCookie(name) {
        const match = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`);
        return match ? match[2] : null;
      }
    }
  );
}
